import { showToast } from "vant";
import { runActivityAssistJob } from "@/services/activityAssistRunner";
const ALL_KEY = "lst_activity_assist_all";
export function getAllJobs() {
    try {
        const raw = localStorage.getItem(ALL_KEY);
        const o = raw ? JSON.parse(raw) : {};
        return o && typeof o === "object" ? o : {};
    }
    catch {
        return {};
    }
}
function persistAll(all) {
    try {
        localStorage.setItem(ALL_KEY, JSON.stringify(all));
    }
    catch (e) {
        console.warn("[assist] persist failed", e);
    }
}
export function jobKey(mode, groupId) {
    return `${String(mode)}:${String(groupId)}`;
}
export function getJob(mode, groupId) {
    return getAllJobs()[jobKey(mode, groupId)] || null;
}
export function setJob(job) {
    if (!job?.mode || job.groupId == null || !job?.activityId || !job?.targetRoute || job.runAtMs == null)
        return;
    const all = getAllJobs();
    all[jobKey(job.mode, job.groupId)] = {
        ...job,
        loopUntilStop: !!job.loopUntilStop
    };
    persistAll(all);
}
export function removeJob(mode, groupId) {
    const all = getAllJobs();
    delete all[jobKey(mode, groupId)];
    persistAll(all);
}
export function resolveTargetRoute(mode, row) {
    if (mode === "exchange")
        return "ExchangeSynthetic";
    if (mode === "recast")
        return "RecastSynthetic";
    if (mode === "decompose")
        return "DecomposeSynthetic";
    return Number(row?.syntheticType) === 4 ? "ExchangeSynthetic" : "ComposeSynthetic";
}
export function startActivityAssistantScheduler() {
    let tid = null;
    const tick = () => {
        if (tid) {
            clearTimeout(tid);
            tid = null;
        }
        const now = Date.now();
        const snapshot = { ...getAllJobs() };
        for (const k of Object.keys(snapshot)) {
            const job = snapshot[k];
            if (!job?.runAtMs || job.runAtMs > now)
                continue;
            removeJob(job.mode, job.groupId);
            showToast(`\u9884\u7EA6\u65F6\u95F4\u5230\uFF1A${job.activityName || "\u6D3B\u52A8"}\uFF08\u540E\u53F0\u6267\u884C\uFF09`);
            void runActivityAssistJob(job).catch((e) => {
                console.warn("[assist] run failed", e);
                showToast(e?.message || "\u5C0F\u52A9\u624B\u6267\u884C\u5F02\u5E38");
            });
        }
        const rest = getAllJobs();
        let nextAt = Infinity;
        for (const k of Object.keys(rest)) {
            const j = rest[k];
            if (j?.runAtMs)
                nextAt = Math.min(nextAt, j.runAtMs);
        }
        const delay = nextAt < Infinity ? Math.min(6e4, Math.max(300, nextAt - Date.now())) : 6e4;
        tid = setTimeout(tick, delay);
    };
    tick();
    const onVis = () => {
        if (document.visibilityState === "visible")
            tick();
    };
    document.addEventListener("visibilitychange", onVis);
    return () => {
        document.removeEventListener("visibilitychange", onVis);
        if (tid)
            clearTimeout(tid);
        tid = null;
    };
}
